import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import useAccordionStyles from '../styles/useAccordionStyles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

interface ICollapsible {
  title: string;
  children: {};
}

function Collapsible(props: ICollapsible) {
  const { title, children, ...accordionProps } = props;
  const [expanded, setExpanded] = useState(false);
  const classes = useAccordionStyles();
  const ExpandIcon = <ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />;

  const toggleExpand = () => setExpanded(!expanded);

  return (
    <Accordion
      {...accordionProps}
      disableGutters
      elevation={0}
      square
      expanded={expanded}
      onChange={toggleExpand}
      className={classes.accordion}
    >
      <AccordionSummary className={classes.accordionSummary} expandIcon={ExpandIcon}>
        <Grid container>
          <Typography>{title}</Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>{children}</AccordionDetails>
    </Accordion>
  );
}

export default Collapsible;
